import React, { useState, useEffect } from "react";
import Table2 from "../Table2/Table2";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import ReactLoading from 'react-loading';
import Switch from "react-switch";
import { useNavigate } from "react-router-dom";
import { deleteVendor, editStatusVendorr, loadVendors } from "../../Redux/Actions/ActionVendors";

function Vendors1() {
    let role = localStorage.getItem('roleA');
    let dispatch = useDispatch();
    let navigate = useNavigate();
    const vendors = useSelector(state => state.vendorss.vendors)
    const loadingVendors = useSelector(state => state.vendorss.loadingVendors)
    let langLocal = localStorage.getItem('absherLang');
    const [t, i18n] = useTranslation();
    const [statusID, setstatusID] = useState(null);
    const [loadStatusID, setloadStatusID] = useState(false);
    useEffect(() => {
        i18n.changeLanguage(localStorage.getItem('absherLang'));
        dispatch(loadVendors())
    }, []);
    const handleDelete1 = (id) => {
        dispatch(deleteVendor(id));
    }
    const editStatus = (id, is_active) => {
        setstatusID(id)
        let active;
        if (is_active == "0") {
            active = "1"
        } else {
            active = "0"
        }
        dispatch(editStatusVendorr(id, active, setloadStatusID))
    }
    const columns1 = [
        {
            name: <span className="color_spann">{t('name_en')}</span>, sortable: true,
            cell: (row) => (
                <span>{row['name']}</span>
            )
        },
        {
            name: <span className="color_spann">{t('name_ar')}</span>, sortable: true,
            cell: (row) => (
                <span>{row['name_ar']}</span>
            )
        },
        {
            name: <span className="color_spann">{t('category')}</span>, sortable: true,
            cell: (row) => (
                <>
                    {
                        row.category != null ? (
                            <span>{row.category.name}</span>
                        ) : <></>
                    }
                </>
            )
        },
        {
            name: <span className="color_spann">{t('email')}</span>,
            cell: (row) => (
                <span>{row['email']}</span>
            )
        },
        {
            name: <span className="color_spann">{t('start_date')}</span>,
            cell: (row) => (
                <span>{row['start_date']}</span>
            )
        },
        {
            name: <span className="color_spann">{t('expire_date')}</span>,
            cell: (row) => (
                <span>{row['expire_date']}</span>
            )
        },
        {
            name: <span className="color_spann">{t('status')}</span>,
            cell: (row) => (
                <>
                    {
                        (row.id === statusID && loadStatusID === true) ? (
                            <ReactLoading type="cylon" color="#36ADB0" height={'35%'} width={'35%'} />
                        ) : (
                            <>
                                {
                                    row.is_active === "0" ? (
                                        <Switch onColor='#36ADB0' checkedIcon={false} uncheckedIcon={false} height={20} width={40} handleDiameter={15} checked={false} onChange={() => { editStatus(row.id, row.is_active) }} />
                                    ) : <Switch onColor='#36ADB0' checkedIcon={false} uncheckedIcon={false} height={20} width={40} handleDiameter={15} checked={true} onChange={() => { editStatus(row.id, row.is_active) }} />
                                }
                            </>
                        )
                    }
                </>

            )
        },
        {
            name: <span className="color_spann">actions</span>,
            cell: (row) => (
                <>
                    {
                        role !== '2' ? (
                            <>
                                <i className="fa fa-eye  icon_edit " onClick={() => toVendorDetails(row.id)} onContextMenu={(e) => {
                                    e.preventDefault();
                                    window.open(`/vendor-details/${row.id}`, '_blank');
                                }} ></i>
                                <i className="fa fa-edit  icon_edit " onClick={() => handleEdit(row.id)} onContextMenu={(e) => {
                                    e.preventDefault();
                                    window.open(`/edit-vendor/${row.id}`, '_blank');
                                }}  ></i>
                                <i className="fa fa-trash icon_delete " onClick={() => handleDelete1(row.id)} ></i>
                            </>
                        ) : <span>No actions</span>
                    }
                </>
            )
        }
    ]
    const handleEdit = (id) => {
        navigate(`/edit-vendor/${id}`)
    }
    const toAddVendor = () => {
        navigate("/add-vendor")
    }
    const toVendorDetails = (id) => {
        navigate(`/vendor-details/${id}`)
    }
    return (
        <>
            <main>
                <div className="page_header" dir={langLocal == "ar" ? "rtl" : "ltr"} >
                    <h2>{t('vendors')}</h2>
                    {
                        role !== '2' && (
                            <button onClick={toAddVendor} >
                                <i className="fa fa-plus" ></i>
                                <span>{t('addvendor')}</span>
                            </button>
                        )
                    }
                </div>
                <div className="div_table" dir={langLocal == "ar" ? "rtl" : "ltr"} >
                    {
                        loadingVendors == false ? (
                            <Table2 col={columns1} roo={vendors} />
                        ) : <div className="div_loading" ><ReactLoading type="spinningBubbles" color="#36ADB0" height={'7%'} width={'7%'} /></div>
                    }
                </div>
            </main>
        </>
    );
}

export default Vendors1;